import type { I18nId } from '@/i18n/config'
import type { Gender } from '@/types/schema/common/gender-schema'

const genderI18nIdMap: Record<Gender, I18nId> = {
  Male: 'kol:edit_field_gender_male',
  Female: 'kol:edit_field_gender_female',
  Unknown: 'autoreport:chart_label_empty_data',
  Else: 'kol:edit_field_gender_other',
} as const

export default genderI18nIdMap
